/* eslint no-underscore-dangle: ["error", { "allow": ["_items", "_id"] }] */

import _ from 'lodash';
import humanize from 'underscore.string/humanize';
import titleize from 'underscore.string/titleize';

import {
  API_CREATE_FAILED,
  API_READ_FAILED,
  API_UPDATE_FAILED,
  API_DELETE_FAILED,
} from '@keypr/redux-json-api/lib/constants';
import settings from '../../config/settings';
import {
  REDIRECT_LOGIN,
  API_UNAUTHORIZED,
  USER_LOGGEDIN,
  USER_LOGOUT,
  LOAD_SELECTED_AFFILIATE,
  SERVICE_REQUEST_STATUS_UPDATE,
  SERVICE_REQUEST_ASSIGNED,
  WORK_ORDER_CREATED,
  WORK_ORDER_STATUS_UPDATE,
  WORK_ORDER_ADD_COMMENT,
  WORK_ORDER_ADD_ATTACHMENT,
  CALL_REFRESHING_FUNC,
  OVERRIDE_COMMENT_ATTACHMENTS,
  OPEN_ADD_COMMENT_ATTACHMENTS,
  SET_FILTER,
  REQUEST_ADD_COMMENT,
  VIEWS_REQUESTS_SET_FILTER,
  VIEWS_REQUESTS_SET_SORT,
  APP_TOGGLE_AVAILABLE, LOCATION_UPDATE,
} from '../types';
import { getPlatform } from '../../utils/mobile';
import GtmService from '../../services/GtmService';
import store from '../../store';

const analytics = (state = {}, action) => {
  let eventAction = '';
  let requestDetail = {};
  let workOrder = {};

  if (store) {
    const ticket = store.getState().ticket;

    // Find a workorder from action payload
    if (ticket.work_order && action.payload) {
      workOrder = ticket.work_order._items.filter(item => item._id === action.payload.id)[0];
    }

    requestDetail = store.getState().views.requestDetail;
  }

  switch (action.type) {
    case REDIRECT_LOGIN: {
      GtmService.dataLayer({
        category: 'Authentication',
        action: 'Session Login Attempted',
        label: window.location.origin,
      });

      // Should be moved to the other reducer (not related to analytics)
      window.setTimeout(() => {
        let clientId = settings.client_id[getPlatform()];

        if (action.payload.type !== null && _.has(settings.client_id, action.payload.type)) {
          clientId = settings.client_id[action.payload.type];
        }
        window.location.href = `${settings.account_url}${settings.oauth_url}?client_id=${clientId}&response_type=${settings.response_type}&redirect_uri=${window.location.origin}`;
      }, 750);
      break;
    }

    case USER_LOGGEDIN: {
      GtmService.dataLayer({
        category: 'Authentication',
        action: 'User Login',
      });

      break;
    }

    case USER_LOGOUT: {
      GtmService.dataLayer({
        category: 'Authentication',
        action: 'User Logout',
      });

      // Should be moved to the other reducer (not related to analytics)
      window.setTimeout(() => {
        let clientId = settings.client_id[getPlatform()];
        if (action.payload.type !== null && _.has(settings.client_id, action.payload.type)) {
          clientId = settings.client_id[action.payload.type];
        }
        window.localStorage.removeItem('oauth_token');
        window.location.href = `${settings.account_url}${settings.logout_url}?next=${settings.oauth_url}%3Fclient_id%3D${clientId}%26response_type%3D${settings.response_type}%26redirect_uri%3D${window.location.origin}`;
      }, 750);

      break;
    }

    case LOAD_SELECTED_AFFILIATE: {
      GtmService.dataLayer({
        category: 'Authentication',
        action: 'Load Affiliate',
        label: action.payload.affiliateId,
      });

      break;
    }

    case API_CREATE_FAILED:
    case API_READ_FAILED:
    case API_UPDATE_FAILED:
    case API_DELETE_FAILED: {
      switch (action.type) {
        case API_CREATE_FAILED:
          eventAction = 'Server Error Create';
          break;
        case API_READ_FAILED:
          eventAction = 'Server Error Read';
          break;
        case API_UPDATE_FAILED:
          eventAction = 'Server Error Update';
          break;
        case API_DELETE_FAILED:
          eventAction = 'Server Error Delete';
          break;
        default:
          eventAction = 'Server Error';
          break;
      }

      GtmService.dataLayer({
        category: 'Network',
        action: eventAction,
        label: action.payload.endpoint,
      });

      break;
    }

    case API_UNAUTHORIZED: {
      GtmService.dataLayer({
        category: 'Network',
        action: 'User Unauthorized',
      });

      break;
    }

    case SERVICE_REQUEST_STATUS_UPDATE: {
      const serviceRequest = requestDetail.request;

      GtmService.dataLayer({
        category: 'Service Requests',
        action: `Status update ${action.payload.status}`,
        label: serviceRequest.type,
        room: serviceRequest.room,
      });

      break;
    }

    case SERVICE_REQUEST_ASSIGNED: {
      const serviceRequest = requestDetail.request;

      GtmService.dataLayer({
        category: 'Service Requests',
        action: `Assigned to ${action.payload.assignee_name}`,
        label: serviceRequest.type,
        room: serviceRequest.room,
      });

      break;
    }

    case REQUEST_ADD_COMMENT: {
      const serviceRequest = requestDetail.request;

      GtmService.dataLayer({
        category: 'Service Requests',
        action: 'Add comment',
        label: serviceRequest.type,
        room: serviceRequest.room,
      });

      break;
    }

    case VIEWS_REQUESTS_SET_FILTER: {
      GtmService.dataLayer({
        category: 'Service Requests',
        action: 'Filter',
        label: action.payload,
      });

      break;
    }

    case VIEWS_REQUESTS_SET_SORT: {
      GtmService.dataLayer({
        category: 'Service Requests',
        action: 'Sort by',
        label: action.payload,
      });

      break;
    }

    case APP_TOGGLE_AVAILABLE: {
      GtmService.dataLayer({
        category: 'Settings',
        action: 'On Duty Toggle',
        label: action.payload.permissions.user.attributes.is_available,
      });

      break;
    }

    case LOCATION_UPDATE: {
      const location = action.payload.attributes;
      let label = null;

      if (location.guest_service_status) {
        label = `Guest Service Status ${location.guest_service_status}`;
      } else if (location.housekeeping_status) {
        label = `Housekeeping Status ${location.housekeeping_status}`;
      }

      GtmService.dataLayer({
        category: 'Rooms',
        action: 'Submit Change',
        label,
      });

      break;
    }

    case WORK_ORDER_CREATED: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Created',
        label: workOrder.type,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case WORK_ORDER_STATUS_UPDATE: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Status Change',
        label: action.payload.status,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case WORK_ORDER_ADD_COMMENT: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Add Comment',
        label: workOrder.type,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case WORK_ORDER_ADD_ATTACHMENT: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Add Attachment',
        label: workOrder.type,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case CALL_REFRESHING_FUNC: {
      if (action.payload && action.payload.key) {
        GtmService.dataLayer({
          category: titleize(humanize(action.payload.key)),
          action: 'Refresh',
          label: action.payload.key,
        });
      }

      break;
    }

    case OVERRIDE_COMMENT_ATTACHMENTS: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Override Comment Attachments',
        label: workOrder.type,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case OPEN_ADD_COMMENT_ATTACHMENTS: {
      GtmService.dataLayer({
        category: 'Work Orders',
        action: 'Open Override Comment Attachments',
        label: workOrder.type,
        priority: workOrder.priority,
        department: workOrder.channel,
        room: _.map(workOrder.locations, location => location.location_name),
      });

      break;
    }

    case SET_FILTER: {
      let category = 'Unknown';
      let label = null;
      const filterType = Object.keys(action.payload)[0];

      switch (filterType) {
        case 'locations':
          category = 'Rooms';
          label = action.payload.locations;
          break;

        case 'serviceRequests':
          category = 'Service Requests';
          label = action.payload.serviceRequests;
          break;

        case 'workordersList':
          category = 'Work Orders';
          label = action.payload.workordersList;
          break;

        default:
          category = 'Unknown';
          break;
      }

      GtmService.dataLayer({
        category,
        action: 'Filter',
        label: label ? label.filterKey : null,
      });

      GtmService.dataLayer({
        category,
        action: 'Sort By',
        label: label ? label.sortKey : null,
      });

      break;
    }

    default: {
      break;
    }
  }
  return state;
};

export default analytics;



// WEBPACK FOOTER //
// ./src/state/reducers/analytics.js